import React from "react";

import StudentDashboardLayout from "./StudentDashboardLayout";

const StudentDashboard = () => {
  return (
    <StudentDashboardLayout>
      <div>Student Dashboard</div>
    </StudentDashboardLayout>
  );
};

export default StudentDashboard;
